export default __webpack_public_path__ + "static/media/HCPOnboarding.9ebc2826.svg";